// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.52);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.loading-spinner {
  width: 64px;
  height: 64px;
  border: 6px solid #fff;
  border-top-color: transparent;
  border-radius: 50%;
  animation: loading-spin 0.8s linear infinite;
}

@keyframes loading-spin {
  to {
    transform: rotate(360deg);
  }
}
.geo-restriction-message {
  position: fixed;
  inset: 0;
  background: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
}

.geo-restriction-content {
  text-align: center;
  padding: 2rem;
  max-width: 600px;
}
.geo-restriction-content h1 {
  font-size: 2rem;
  margin-bottom: 1rem;
  color: #333;
}
.geo-restriction-content p {
  font-size: 1.25rem;
  color: #666;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,QAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,6BAAA;EACA,kBAAA;EACA,4CAAA;AACF;;AAEA;EACE;IACE,yBAAA;EACF;AACF;AAEA;EACE,eAAA;EACA,QAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AAAF;;AAGA;EACE,kBAAA;EACA,aAAA;EACA,gBAAA;AAAF;AAEE;EACE,eAAA;EACA,mBAAA;EACA,WAAA;AAAJ;AAGE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AADJ","sourcesContent":[".loading-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.52);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1050;\n}\n\n.loading-spinner {\n  width: 64px;\n  height: 64px;\n  border: 6px solid #fff;\n  border-top-color: transparent;\n  border-radius: 50%;\n  animation: loading-spin 0.8s linear infinite;\n}\n\n@keyframes loading-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.geo-restriction-message {\n  position: fixed;\n  inset: 0;\n  background: #f8f9fa;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1100;\n}\n\n.geo-restriction-content {\n  text-align: center;\n  padding: 2rem;\n  max-width: 600px;\n\n  h1 {\n    font-size: 2rem;\n    margin-bottom: 1rem;\n    color: #333;\n  }\n\n  p {\n    font-size: 1.25rem;\n    color: #666;\n    margin: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
